module.exports = __webpack_public_path__ + "assets/img/icon-3.67fe5c46.png";